import { render, staticRenderFns } from "./shopListModal.vue?vue&type=template&id=b723d8ca&scoped=true"
import script from "./shopListModal.vue?vue&type=script&lang=js"
export * from "./shopListModal.vue?vue&type=script&lang=js"
import style0 from "./shopListModal.vue?vue&type=style&index=0&id=b723d8ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b723d8ca",
  null
  
)

export default component.exports